export default __webpack_public_path__ + "static/media/ISO 14K 2027-2.fbb69a34.png";